<template>
  <div class="goods-want-index">
    <NavTop :title="title" />
    <van-form @submit="onSubmit">
      <van-field
        label="游戏"
        readonly
        v-model="form.gameName"
        is-link
        placeholder="请选择游戏"
        @focus="show = true"
        :rules="[{ required: true, message: '游戏不能为空' }]"
      ></van-field>
      <van-action-sheet
        v-model="show"
        :actions="gameList"
        @select="onSelect"
      ></van-action-sheet>
      <van-field
        label="运营商"
        readonly
        v-model="form.os"
        is-link
        placeholder="请选择运营商"
        :rules="[{ required: true, message: '运营商不能为空' }]"
        @focus="show2 = true"
      ></van-field>
      <van-action-sheet
        v-model="show2"
        :actions="channelList"
        @select="onSelect2"
      ></van-action-sheet>
      <div style="padding: 16px 50px">
        <van-button round block type="info" native-type="submit"
          >下一步</van-button
        >
      </div>
    </van-form>
  </div>
</template>
<script>
import NavTop from "@/components/nav-top/index.vue";
import { getGameDict } from "@/api/home";
export default {
  name: "GoodsWantIndex",
  components: { NavTop },
  data() {
    return {
      title: "",
      show: false,
      show2: false,
      form: {},
      gameList: [],
      channelList: [
        { name: "不限", value: 0 },
        { name: "安卓", value: 1 },
        { name: "ios", value: 2 },
      ],
    };
  },
  mounted() {
    this.getGameList();
    if (this.$route.query.type == 1) {
      this.title = "商品求购";
    } else if (this.$route.query.type == 2) {
      this.title = "商品出售";
    }
    if (this.$route.query.id) {
      this.form.id = this.$route.query.id;
    }
    if (this.$route.query.gameId) {
      this.form.gameId = this.$route.query.gameId;
    }
    if (this.$route.query.gameName) {
      this.form.gameName = this.$route.query.gameName;
    }
  },
  methods: {
    onSelect(item) {
      this.show = false;
      this.form.gameName = item.name;
      this.form.gameId = item.value;
    },
    onSelect2(item) {
      this.show2 = false;
      this.form.os = item.name;
      this.form.channelId = item.value;
    },
    onSubmit() {
      if (this.$route.query.type == 1) {
        this.$router.push({ path: "/goods-want-submit", query: this.form });
      } else if (this.$route.query.type == 2) {
        this.$router.push({ path: "/publish-goods-submit", query: this.form });
      }
    },
    getGameList() {
      getGameDict().then((res) => {
        this.gameList = res;
      });
    },
  },
};
</script>
<style scoped>
.goods-want-index .top {
  height: 44px;
  line-height: 44px;
  font-size: 16px;
  background: #ebebeb;
  position: relative;
  text-align: center;
}
.goods-want-index .top .back {
  position: absolute;
  left: 10px;
  top: 10px;
  width: 24px;
}
</style>